// JsFromRoutes CacheKey a82ee17f5773628a7c3ca2b5c2995ca4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/banners'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/banners'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/help/banners/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/help/banners/:id'),
}
